export const routes = {
  ABOUTUS: '/about-us',
  HOME: '/',
  INVITE: '/invite',
  SIGNIN: '/signin',
  DRIVE: '/drive/',
  ACCOUNT: '/account',
  SUPPORT: '/support',
  BILLINGS: '/billings',
  IRIS: '/services',
  EDITOR: '/documents/',
  LEARNING: '/learn',
};
